<template>
  <v-container
    id="dashboard"
    tag="section"
    fluid
    v-if="listaBaixaTucagem[0] !== 'errorFound'"
  >
    <h2 class="mx-auto my-4">Gráficos Box Plot</h2>
    <v-row>
      <v-col sm="12">
        <v-card
          v-for="(variavel, i) in variaveisList"
          :key="i"
          class="mt-10 mr-0 ml-0 pa-0 max-height: 150px"
        >
          <br>
          <div class="caption font-weight-light ml-2 mt-n2 mb-2">
            Box Plot TUCs {{variavel.toUpperCase()}}
          </div>
          <grafico-box-plot-predicao  
            :idPredicao="parseInt($route.params.id)"
            :variavelValor="variavel"
          />
        </v-card>
      </v-col>
    </v-row>
    <h2 class="mx-auto my-4">Gráficos de Frequência</h2>
    <v-row
      v-for="(element, i) in listaBaixaTucagem"
      :key="i"
    >
      <v-col
        v-for="(variavel, i) in variaveisList"
        :key="i"
        sm="6"
      >
        <v-card class="mt-10 mr-0 ml-0 pa-0 max-height: 150px">
          <br>
          <div class="caption font-weight-light ml-2 mt-n2 mb-2">
            Histograma {{ element.btg_tucagem }} {{variavel.toUpperCase()}}
          </div>
          
          <grafico-histograma-predicao 
            :base="predicao.base.toLowerCase()"
            :idPredicao="parseInt($route.params.id)" 
            :idBaixaTucagem="parseInt(element.btg_id)"
            :variavelValor="variavel"
            @recharge="getCenariosProcessados()"
          />
        </v-card>
      </v-col>
    </v-row>
    <h2 class="mx-auto my-4">Cenários Processados</h2>
    <v-row>
      <cenarios-predicoes-baixas-data-table 
        :base="predicao.base"
        :items="itemsCenarios"
        :loading="loading"
        :downloadProgressDataCenario.sync="downloadProgressData"
        @recharge="getCenariosProcessados()"
      />
    </v-row>

    <v-snackbar
      :value="Object.values(downloadProgressData).length > 0"
      :timeout="0"
      right vertical
    >
      <div style="overflow: auto; max-height: 40vh;">
        <general-progress-bars
          :items="downloadProgressData"
          prefixText="Baixando Cenário"
        />
      </div>
    </v-snackbar>
    
  </v-container>
</template>

<script>

import PredicoesService from '@/services/PredicoesBaixasService.js';
import pusherMixins from "@/mixins/pusherMixins";

export default {
  name: 'ResultadoPredicaoBaixa',
  mixins: [pusherMixins],

  components: { 
    GraficoBoxPlotPredicao: () => import('@/components/predicoesBaixas/graficos/GraficoBoxPlotPredicao'),
    GraficoHistogramaPredicao: () => import('@/components/predicoesBaixas/graficos/GraficoHistogramaPredicao'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    CenariosPredicoesBaixasDataTable: () => import('@/components/predicoesBaixas/CenariosPredicoesBaixasDataTable')
  },

  mounted(){
    this.subscribe();
    this.getListaBaixasTucagem();
    this.getPredicao();
    this.getCenariosProcessados();
  },

  data: () => ({
    listaBaixaTucagem: [],
    predicao: {},
    variaveisList: [],
    downloadProgressData: {},
    itemsCenarios: [],
    loading: false
  }),

  methods: {
    getListaBaixasTucagem() {
      PredicoesService.getTucagemLista(this.$route.params.id)
        .then(response => {
          var aux = {};
          response.data.lista.forEach(element => {

            aux.btg_id      = element.btg_id;
            aux.btg_tucagem = element.btg_tucagem;

            this.listaBaixaTucagem.push(aux);

            aux = {};

          });
        })
        .catch(error => {
          console.log(error);
          this.listaBaixaTucagem.push('errorFound');
          this.$toast.error(
            'Erro ao montar gráficos box plot, não foram encontrados bens com a tucagem especificada.',
            '',
            {position:'topRight', timeout:4000, onClosed: () => { this.$router.replace({ name: 'Predições de Baixas Histórico' }) } }
          );
        });
    },

    getPredicao() {
      PredicoesService.getPredicao(this.$route.params.id)
        .then(response => {
          this.predicao = response.data.predicao;
          this.variaveisList = this.predicao.variaveis.split(",");
        })
        .catch(error => console.log(error));
    },

    subscribe() {
      this.pusherChannel.bind('reload-pag-cenarios-predicao', () => {
        this.getCenariosProcessados();
      });
    },
    
    getCenariosProcessados() {
      this.loading = true;
      this.itemsCenarios = [];

      PredicoesService.getCenariosProcessados(this.$route.params.id)
        .then(response => {
          response.data.cenarios.forEach(element => {
            element.loading = false;
            this.itemsCenarios.push(element);
          });
        })
        .catch(error => console.log(error))
        .finally(this.loading = false);
    }
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  }
}
</script>

<style>
 .v-snack__content {
  padding: 0px !important;
  min-height: 15px !important;
 }
</style>